module.exports = __webpack_public_path__ + "static/media/noAvatar.eb4636b0.jpg";